import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import dates from 'react-big-calendar/lib/utils/dates'
import BigCalendar from 'react-big-calendar'
import * as instructorActions from '../../_actions/employeeLeave.actions'
import { mergeWithDefaults } from 'react-big-calendar/lib/localizer'
import ToolbarMonth from './ToolbarMonth'
import _ from 'lodash'
import { Pagination } from 'antd'
// import "antd/dist/antd.css";
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import { navigate } from './constants'

import LeaveReportContents from './LeaveReportContent'
import { reports } from './constants'
import { viewConstants } from '../../_constants/view.constants'

const moment = require('moment')
const _localizer = BigCalendar.momentLocalizer(moment)

const localizer = mergeWithDefaults(_localizer, 'en-NZ', {}, {})

const DEFAULT_PAGE_SIZE = 20
class LeaveReport extends Component {
    static defaultProps = {
        getNow: () => new Date(),
    }
    state = {
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEvents: [],
        displayEmployees: [],
        show: false,
        activeTab: '1',
        selectedBranch: {},
        selectedDepartment: {},
        mounted: false,
        current: [],
        currentDate: new Date(),
        pageSize: DEFAULT_PAGE_SIZE,
        paginationEmployees: [],
        filterFlag: false,
    }

    componentDidMount = () => {
        const defaultRange = this.range(this.props.getNow())
        this.setState({ current: defaultRange })
        this.initPagination(1)

        const options = {
            range: viewConstants.MONTH,
            time: new Date(),
        }
        this.props.actions.fetchEmployeeLeave(options)
    }

    initPagination = current => {
        const paginationEmployees = this.props.displayEmployeesLeaveRpt
        this.setState({
            paginationEmployees: this.props.displayEmployeesLeaveRpt,
            pageSize: DEFAULT_PAGE_SIZE,
        })
        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return current == Math.floor(index / DEFAULT_PAGE_SIZE) + 1
        })

        if (paginationEmployees.length > DEFAULT_PAGE_SIZE) {
            this.setState({
                displayEmployees: filteredEmployees,
                filterFlag: true,
            })
        }
    }

    range = date => {
        let start = dates.startOf(date, 'month')
        let end = dates.endOf(date, 'month')

        return dates.range(start, end)
    }

    handleRangeChange = date => {
        const range = this.range(date)
        this.setState({ current: range, currentDate: date })

        const options = {
          range: viewConstants.MONTH,
          time: date,
      }
      this.props.actions.fetchEmployeeLeave(options)        
    }

    handleBranchChange = branch => {
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch.value !== 'all') {
            filterCond.branch = branch.value
        }
        if (selectedDepartment.value && selectedDepartment.value !== 'all') {
            filterCond.department = selectedDepartment.value
        }
        filterCond.view = reports.LEAVE
        this.props.actions.updateLeaveReportDisplayEvents(filterCond)
        this.setState({
            selectedBranch: branch,
        })
    }

    handleDepartmentChange = department => {
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department.value !== 'all') {
            filterCond.department = department.value
        }
        if (selectedBranch.value && selectedBranch.value !== 'all') {
            filterCond.branch = selectedBranch.value
        }
        filterCond.view = reports.LEAVE

        this.props.actions.updateLeaveReportDisplayEvents(filterCond)
        this.setState({
            selectedDepartment: department,
        })
    }

    handleNavigate = (action, newDate) => {
        // const currentDate = this.state.currentDate

        switch (action) {
            case navigate.PREVIOUS:
                // const previousMonth = dates.subtract(currentDate, 1, 'month')
                this.handleRangeChange(newDate)
                break
            case navigate.NEXT:
                // const nextMonth = dates.add(currentDate, 1, 'month')
                this.handleRangeChange(newDate)
                break
            case navigate.TODAY:
                this.handleRangeChange(new Date())
                break
            case navigate.DATE:
                this.handleRangeChange(newDate)
                break
            default:
        }
    }

    onShowSizeChange = (current, pageSize) => {
        const paginationEmployees = this.props.displayEmployeesLeaveRpt
        this.setState({
            paginationEmployees: this.props.displayEmployeesLeaveRpt,
            pageSize: pageSize,
        })

        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return current == Math.floor(index / pageSize) + 1
        })

        this.setState({ displayEmployees: filteredEmployees, filterFlag: true })
    }

    onPageChange = (page, pageSize) => {
        const paginationEmployees = this.props.displayEmployeesLeaveRpt
        this.setState({
            paginationEmployees: this.props.displayEmployeesLeaveRpt,
            pageSize: pageSize,
        })

        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return page == Math.floor(index / pageSize) + 1
        })

        this.setState({ displayEmployees: filteredEmployees, filterFlag: true })
    }

    render() {
        return (
            <div>
                <div className="row">
                    {/* <div className="col-sm-2">
            <div className="reportToolBar">
              <BrancheSelect handleChange={this.handleBranchChange.bind(this)} />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="reportToolBar">
              <DepartmentSelect
                handleChange={this.handleDepartmentChange.bind(this)}
              />
            </div>
          </div> */}
                    <div className="col-sm-6">
                        <ToolbarMonth
                            onNavigate={this.handleNavigate}
                        />
                    </div>
                    <div className="col-sm-6 reportpaging">
                        <Pagination
                            showSizeChanger
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onPageChange}
                            pageSizeOptions={['10', '20', '50']}
                            defaultCurrent={1}
                            pageSize={this.state.pageSize}
                            total={this.props.displayEmployeesLeaveRpt.length}
                        />
                    </div>
                    <div>
                        <LeaveReportContents
                            localizer={localizer}
                            range={this.state.current}
                            getNow={this.props.getNow}
                            employees={
                                this.state.filterFlag
                                    ? this.state.displayEmployees
                                    : this.props.displayEmployeesLeaveRpt
                            }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        events: state.roster.displayWeeklyEvents,
        displayEmployeesLeaveRpt: state.roster.displayEmployeesLeaveRpt,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaveReport)
